"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _ChevronLeft = _interopRequireDefault(require("@mui/icons-material/ChevronLeft"));
var _ChevronRight = _interopRequireDefault(require("@mui/icons-material/ChevronRight"));
var _AccessTime = _interopRequireDefault(require("@mui/icons-material/AccessTime"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      height: 40,
      marginBottom: -40,
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider
    },
    button: {
      height: 32,
      width: 32,
      margin: '4px 24px',
      padding: 0
    },
    left: {
      float: 'left'
    },
    right: {
      float: 'right'
    },
    bottomLeft: {
      position: 'absolute',
      left: 0,
      bottom: 0
    }
  };
};
var _ref2 = /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, null);
var _ref3 = /*#__PURE__*/_react.default.createElement(_ChevronRight.default, null);
var _ref4 = /*#__PURE__*/_react.default.createElement(_AccessTime.default, null);
var NavBar = function NavBar(_ref) {
  var classes = _ref.classes,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en_US' : _ref$locale,
    localeUtils = _ref.localeUtils,
    nextMonth = _ref.nextMonth,
    onClockClick = _ref.onClockClick,
    onPreviousClick = _ref.onPreviousClick,
    onNextClick = _ref.onNextClick,
    previousMonth = _ref.previousMonth,
    showClockButton = _ref.showClockButton;
  var months = localeUtils.getMonths(locale);
  var prev = "".concat(months[previousMonth.getMonth()], " ").concat(previousMonth.getFullYear());
  var next = "".concat(months[nextMonth.getMonth()], " ").concat(nextMonth.getFullYear());
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: (0, _classnames.default)(classes.button, classes.left),
    onClick: function onClick() {
      return onPreviousClick();
    },
    title: prev,
    size: "large"
  }, _ref2), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: (0, _classnames.default)(classes.button, classes.right),
    onClick: function onClick() {
      return onNextClick();
    },
    title: next,
    size: "large"
  }, _ref3), showClockButton && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: (0, _classnames.default)(classes.button, classes.bottomLeft),
    onClick: function onClick() {
      return onClockClick();
    },
    size: "large"
  }, _ref4));
};
NavBar.defaultProps = {
  showClockButton: false
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiNavBar'
})(NavBar);